import type { WorldLevel } from '@/queries/constants'

export const UPDATE_LAST_VIEWED_AT_DELAY_MS = 1000

export const MIN_LEVEL_WITH_TEXT_NOTIFICATIONS: WorldLevel = 'tutor'
